module.exports = __webpack_public_path__ + "img/twitter.bfb3b141.svg";